import { platformEnv } from '@/platform/config/env'
import { createHttpClient } from '@/platform/http/client'
import type { Taxonomy, TaxonomyDraft, TaxonomyTerm, TaxonomyTermDraft } from '../model/taxonomy'

const client = createHttpClient(platformEnv.courseApiUrl)

export const taxonomiesApi = {
  // Taxonomies
  async listTaxonomies(subjectId: number): Promise<Taxonomy[]> {
    return (await client.request<Taxonomy[]>({ url: `/v1/admin/taxonomies?subject_id=${subjectId}`, method: 'GET' })).data
  },

  async getTaxonomy(idOrCode: string | number): Promise<Taxonomy> {
    return (await client.request<Taxonomy>({ url: `/v1/admin/taxonomies/${idOrCode}`, method: 'GET' })).data
  },

  async createTaxonomy(payload: TaxonomyDraft): Promise<Taxonomy> {
    const res = (await client.request<Taxonomy>({ url: '/v1/admin/taxonomies', method: 'POST', data: payload })).data
    return res
  },

  async updateTaxonomy(idOrCode: string | number, payload: Partial<TaxonomyDraft>): Promise<Taxonomy> {
    const res = (await client.request<Taxonomy>({ url: `/v1/admin/taxonomies/${idOrCode}`, method: 'PUT', data: payload })).data
    return res
  },

  async deleteTaxonomy(idOrCode: string | number): Promise<void> {
    await client.request<void>({ url: `/v1/admin/taxonomies/${idOrCode}`, method: 'DELETE' })
  },

  // Taxonomy Terms
  async listTerms(taxonomyIdOrCode?: string | number, subjectId?: number): Promise<TaxonomyTerm[]> {
    let url = taxonomyIdOrCode ? `/v1/admin/taxonomies/${taxonomyIdOrCode}/terms` : '/v1/admin/taxonomy-terms'
    if (subjectId) {
      url += (url.includes('?') ? '&' : '?') + `subject_id=${subjectId}`
    }
    return (await client.request<TaxonomyTerm[]>({ url, method: 'GET' })).data
  },

  async createTerm(taxonomyId: number, payload: Omit<TaxonomyTermDraft, 'taxonomy_id'>): Promise<TaxonomyTerm> {
    const res = (await client.request<TaxonomyTerm>({
      url: `/v1/admin/taxonomies/${taxonomyId}/terms`,
      method: 'POST',
      data: payload,
    })).data
    return res
  },

  async updateTerm(termId: number, payload: Partial<TaxonomyTermDraft>): Promise<TaxonomyTerm> {
    const res = (await client.request<TaxonomyTerm>({
      url: `/v1/admin/taxonomy-terms/${termId}`,
      method: 'PUT',
      data: payload,
    })).data
    return res
  },

  async deleteTerm(termId: number): Promise<void> {
    await client.request<void>({ url: `/v1/admin/taxonomy-terms/${termId}`, method: 'DELETE' })
  },
}
